import React from "react"
import { useTranslation } from "react-i18next"
import styles from "../EventDashboardV2.module.scss"

interface TrafficStripProps {
  uniqueVisitors: number
  totalVisits: number
  registrations: number
}

const formatNumber = (value: number): string => {
  if (!Number.isFinite(value) || value <= 0) return "0"
  return value.toLocaleString()
}

const formatConversion = (registrations: number, uniqueVisitors: number): string => {
  if (!uniqueVisitors || uniqueVisitors <= 0) return "—"
  const pct = Math.min(100, Math.round((registrations / uniqueVisitors) * 100))
  return `${pct}%`
}

// Lightweight metrics strip shown above the overview cards for open events.
// Keeps the card grid focused on RSVP/QR status while still surfacing the
// traffic funnel that only exists when the event has a public registration
// page.
const TrafficStrip: React.FC<TrafficStripProps> = ({
  uniqueVisitors,
  totalVisits,
  registrations,
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.trafficStrip} role="group" aria-label={t("eventDashboardV2.labels.traffic")}>
      <div className={styles.trafficStripMetric}>
        <span className={styles.trafficStripLabel}>
          {t("eventDashboard.trafficUniqueVisitors")}
        </span>
        <span className={styles.trafficStripValue}>
          {formatNumber(uniqueVisitors)}
        </span>
      </div>
      <span className={styles.trafficStripDivider} aria-hidden />
      <div className={styles.trafficStripMetric}>
        <span className={styles.trafficStripLabel}>
          {t("eventDashboard.trafficTotalVisits")}
        </span>
        <span className={styles.trafficStripValue}>
          {formatNumber(totalVisits)}
        </span>
      </div>
      <span className={styles.trafficStripDivider} aria-hidden />
      <div className={styles.trafficStripMetric}>
        <span className={styles.trafficStripLabel}>
          {t("eventDashboard.trafficConversion")}
        </span>
        <span className={styles.trafficStripValue}>
          {formatConversion(registrations, uniqueVisitors)}
        </span>
      </div>
    </div>
  )
}

export default TrafficStrip
